import { ServerMinusOutlineIcon } from './ServerMinusOutlineIcon';

/**
 * author: Kadensvw
 * id 1BFB5C91-DDE1-4902-A46F-27E80C5502E3
 * name server-minus-outline
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/server-minus-outline.svg
 * tags
 */
export const ServerRemoveOutlineIcon = ServerMinusOutlineIcon;
export default ServerRemoveOutlineIcon